module.exports = __webpack_public_path__ + "media/conversa/ico_sofia_close-ca1c1830.png";